import React, { Suspense } from 'react';
import dynamic from 'next/dynamic';

import { useBusinessIdStore } from '~/store/global/useBusinessIdStore';

const DynamicCashnyChatAssistantProvider = dynamic(
  () =>
    import('@kcd/cashny-entry-kit').then((res) => res.ChatAssistantProvider),
  {
    ssr: false,
  },
);

const DynamicCashnyHeaderButton = dynamic(
  () => import('@kcd/cashny-entry-kit').then((res) => res.CashnyHeaderButton),
  {
    ssr: false,
  },
);

function CashnyHeaderButtonContent() {
  const { businessId } = useBusinessIdStore();

  return (
    <DynamicCashnyChatAssistantProvider
      feature="MARKET"
      businessId={businessId}
    >
      <DynamicCashnyHeaderButton size={32} modalClassName="pt-safe-area" />
    </DynamicCashnyChatAssistantProvider>
  );
}

export function CashnyHeaderButton() {
  return (
    <Suspense fallback={<></>}>
      <CashnyHeaderButtonContent />
    </Suspense>
  );
}
